/* eslint-disable no-confusing-arrow */
import { colors } from 'syngenta-digital-cropwise-react-ui-kit';
import layers from '../../../../../assets/icons/layers.svg';
import soil from '../../../../../assets/icons/soil.svg';
import area from '../../../../../assets/icons/area.svg';
import {
  StyledButton,
  StyledTooltip,
  TooltipContainer,
  TooltipIcon,
  TooltipRadio,
  TooltipRow,
  TooltipText,
  TooltipTitle,
} from './MapViewLayers.styles';
import { useFlowActions } from 'context/actions/flowActions';
import { useTranslation } from 'react-i18next';
import track from 'utils/amplitudeWrapper';

interface MapViewLayersProps {
  id?: string;
  isFieldsView: boolean;
  isMobile?: boolean;
}

export const MapViewLayers = ({ id, isFieldsView, isMobile }: MapViewLayersProps): JSX.Element => {
  const [t] = useTranslation();
  const { setIsFieldsView, setShowLayerSelectionPopUp } = useFlowActions();

  const handleViewChange = (value: boolean) => {
    if (isMobile) {
      return;
    }
    if (value) {
      track('user interacts with 1st map and products', {
        'field layer clicked': true,
      });
    } else {
      track('user interacts with 1st map and products', {
        'soil layer clicked': true,
      });
    }
    setIsFieldsView({ fieldView: value });
  };

  const handleLayerButtonClick = () => {
    if (isMobile) {
      setShowLayerSelectionPopUp({ show: true });
    }
  };

  const tooltipProps = {
    title: (
      <TooltipContainer data-testid={'MapViewTooltip'}>
        <TooltipTitle>{t('Map view')}</TooltipTitle>
        <TooltipRow onClick={() => handleViewChange(true)}>
          <TooltipIcon>
            <img src={area} alt="Fields" />
          </TooltipIcon>
          <TooltipText>{t('Fields')}</TooltipText>
          <TooltipRadio
            data-testid={'fieldRadio'}
            checked={isFieldsView === true}
          />
        </TooltipRow>
        <TooltipRow onClick={() => handleViewChange(false)}>
          <TooltipIcon>
            <img src={soil} alt="Soil" />
          </TooltipIcon>
          <TooltipText>{t('Soil')}</TooltipText>
          <TooltipRadio
            data-testid={'soilRadio'}
            checked={isFieldsView === false}
          />
        </TooltipRow>
      </TooltipContainer>
    ),
    fixedTooltipLabel: true,
  };
  return (
    <StyledTooltip placement="left" color={colors.neutral90} title={t('Map View')}>
      <StyledTooltip
        placement="leftTop"
        color={colors.neutral90}
        showArrow={false}
        trigger={!isMobile ? 'click' : ''}
        getPopupContainer={(triggerNode: HTMLElement) =>
          triggerNode.parentElement ? triggerNode.parentElement : document.body
        }
        {...tooltipProps}
      >
        <StyledButton id={id} data-testid={id} onClick={handleLayerButtonClick}>
          <img src={layers} alt="Map View" />
        </StyledButton>
      </StyledTooltip>
    </StyledTooltip>
  );
};
